// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display-media-modal .display-media{padding-bottom:1.5rem}", ""]);
// Exports
module.exports = exports;
